import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "\u8BA2\u5355\u901A\u77E5"
});
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M19.8208 5.42453C19.4055 4.13755 18.1229 3.14628 17.158 2.55731C16.499 2.1564 15.6586 2.14709 14.99 2.53328L13.2676 3.52886C12.4886 3.97916 11.5118 3.97916 10.7328 3.52886L9.01103 2.53328C8.34244 2.14709 7.50201 2.1564 6.84301 2.55731C5.87687 3.14628 4.59427 4.13755 4.17901 5.42453C3.4841 7.5771 2.44304 10.2262 5.04634 13.2068C5.04634 13.2068 3.65848 18.8371 6.95539 21.4863C6.95539 21.4863 9.36429 22.5207 9.0388 20.4925C8.82762 19.1754 8.84312 14.296 11.9999 14.0576C15.1573 14.296 15.1728 19.176 14.961 20.4925C14.6361 22.5207 17.0437 21.4863 17.0437 21.4863C20.3419 18.8371 18.9534 13.2068 18.9534 13.2068C21.5574 10.2268 20.5157 7.5771 19.8208 5.42453Z",
  fill: "#BDC3CD"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var ____ = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { ____ as default };
